<template>
<div class="container-fluid" >

 <div class="card border-success">

  <div class="card-header text-white bg-primary">
    <h4><i style="color:#FFD700" class="fas fa-newspaper mr-2" aria-hidden="true"></i>RIEPILOGO ORDINI TUTTI I FORNITORI</h4>
  </div> 

 <div class="card-body"> 
  
 <div class="row">
 <div  v-if="items.length==0" class="col-md-4"> 

<div class="card border-info" >
  <div class="card-header bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-dark">

  <form name="filter" v-on:submit.prevent="submit()">
    <store-select v-bind:props="store"  @update="setStoreId"></store-select>
    <season-select v-bind:props="season"  @update="setSeasonId"></season-select>
    <year-select  v-bind:props="season_year" @update="setYear"></year-select>
    <department-select v-bind:props="department" @update="setDepartmentId"></department-select>
  

    <div class="form-check form-check-inline">
    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="0" v-model="typeId" @change="setTypeId(typeId)">
      <label class="form-check-label" for="inlineRadio1">     
        <strong>ORDINATO/CONSEGNATO</strong></label>
    </div>

    <div class="form-check form-check-inline ">
    <input class="form-check-input " type="radio" name="inlineRadioOptions" id="inlineRadio2" value="1" v-model="typeId" @change="setTypeId(typeId)">
      <label class="form-check-label" for="inlineRadio2">
        <strong>SOLO ORDINATO ANCORA DA CONSEGNARE</strong>        
      </label>
    </div>
   

   <div class="card-footer bg-transparent border-info"> 
   <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
   <button type="submit" :disabled="spinner"  class="btn btn-primary float-right">
    <i class="far fa-play-circle  mr-2"></i>
    ESEGUI
      <span v-if="spinner" class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>
     </button>           


  </div>
  </form>
 
  </div>
</div>

 </div>


<div v-else class="col">
  <h4 class="card-title"> 
    <strong>
     {{ store.name }} {{ season.name  }} {{season_year.year}} {{ department.name }} {{ type  }}
  </strong>
  </h4>
  <button v-if="items.length>0"  @click="items=[],row_total=[]" type="button"  class="btn btn-secondary  ml-1 mb-1">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    RITORNA A PARAMETRI RICERCA
  </button> 

  <button :disabled="items.length==0 || spinner_pdf == true" @click="exportToPDF()" type="button"   class="btn btn-primary ml-3 mb-1 ">
    <i class="fas fa-file-export mr-2"></i>
      ESPORTA PDF
      <span v-if="spinner_pdf" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  </button>  
  <div class="table-wrapper-scroll-y my-custom-scrollbar">

  <table id='my-table' class="table table table-hover table-sm  mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col"></th>   
        <th scope="col">FORNITORE</th>   
        <th scope="col">BRAND</th>
        <th scope="col">REPARTO</th>                
        <th class="text-right" scope="col">ORDINATO</th>        
        <th class="text-right" scope="col">CONSEGNATO</th>
                        
        <th class="text-right text-nowrap" scope="col">ORDINATO €</th>
        <th class="text-right text-nowrap" scope="col">CONSEGNATO €</th>
                
      </tr>
    </thead>
    <tbody>

      <tr :style="{color: setColor(item),fontSize: setFontSize(item),fontWeight:item.brand == null ? 'bold':'normal' }"   data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in items" :key="index">

        <td v-if="item.row_num  == 1 ">
          <i style="color:blue" class="fas fa-thumbtack " aria-hidden="true"></i>
           
        </td> 
       
        <td v-else>

        </td>
                               
        <td >{{item.supplier}}</td>                      

        <td >{{item.brand}}</td>   
        <td >{{item.department}}</td>                        
        

        <td class="text-right">{{fmt2(item.total1_qty)}} </td>        
        <td :style ="{color:item.total2_qty == 0 && item.brand != null && item.department != null ? 'red':''}" class="text-right">{{fmt2(item.total2_qty)}}</td>        
        <td class="text-right">{{fmt1(item.total1_val)}}</td>
        <td class="text-right">{{fmt1(item.total2_val)}}</td>
               
      </tr> 
    </tbody>
    <tfoot>
        <tr data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in row_total" :key="index"> 
        <td> </td>
        <td> </td>
        <td> </td>
        <td> </td>
        
        
        
        <td class="text-right">{{fmt2(item.total1_qty)}} </td>        
        <td class="text-right">{{fmt2(item.total2_qty)}}</td>        
        <td class="text-right">{{fmt1(item.total1_val)}}</td>
        <td class="text-right">{{fmt1(item.total2_val)}}</td>
        
        
        </tr>   
    </tfoot>    
  </table>

</div>



</div>  

</div>

</div>

</div>

</div>

</template>
<script>
//import axios             from "axios";
import api               from '@/api'
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';

import seasonSelect      from '@/components/common/SeasonSelect_1.vue'
import yearSelect        from '@/components/common/YearSelect_1.vue'
import departmentSelect  from '@/components/common/DepartmentSelect_1.vue'
import storeSelect        from '@/components/common/StoreSelect_1.vue'


import jsPDF             from 'jspdf';
import fmt                from '@/components/mixins/fmt.js'


export default {
  mixins:[fmt], 
  components: {alertBox,seasonSelect,yearSelect,departmentSelect,storeSelect},
  data() {
    return {

      typeId          : "0",
      type            : 'ORDINATO/CONSEGNATO',
      pdf_title       : 
      {
        
        /*supplier      : 'Tutti i fornitori',*/
        department    : 'Tutti i reparti'
        
      },
      store           : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false,
        name          : ''

      },
      season          : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        type          : true,
        name           : '' 


      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
 
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false,
        name          : ''
       
      },
      
      
      data1           : null,
      data2           : new Date().toISOString().slice(0,10),
      
      
      
      spinner         : false,
      spinner_pdf     : false,
      

      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],
      row_total       : [],
      grouping        : [],
      group_by        : 0
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {

    //this.getGrouping()
  },
  methods: {
   setStoreId(storeId,e)
    {
      this.store.Id        = storeId
      this.store.name = e.target.options[e.target.options.selectedIndex].text     
      this.pdf_title.store = e.target.options[e.target.options.selectedIndex].text     
      if(storeId == 0)
      {
        this.store.name = ''
      }
      
    },
   setTypeId(Id) 
   {
    this.type = Id == '0' ? 'ORDINATO/CONSEGNATO' : 'SOLO ORDINATO ANCORA DA CONSEGNARE'
    
   }, 
   setColor(item)
   {
       let color = 'black'
      
        /*
       if(item.brand == null )
       {
           color = 'blue'
       }
        */
       
       if(item.brand == null && item.department == null)
       {
           color =  'green'
       }

       return color

   },
   setFontSize(item)
   {
    let fontSize = '14px'

    /*
    if(item.brand == null )
       {
           fontSize = '18px'
       }
       */
    if(item.brand == null && item.department == null)
       {
           fontSize = '22px'
       }
       
       return fontSize
   },



   
   async  exportToPDF()
    {
      function wait(ms) 
      {
          return new Promise(resolve => {
          setTimeout(() => { resolve('') },ms);
          })
      }

      const addFooters = doc => {
          const pageCount = doc.internal.getNumberOfPages()
          doc.setFont('helvetica', 'italic')
          doc.setFontSize(8)
          for (var i = 1; i <= pageCount; i++) 
          {
            doc.setPage(i)

            doc.text('Pag. ' + String(i) + ' di ' + String(pageCount), 50,200, {
            align: 'center'})
          }
      }
       

      this.spinner_pdf = true
      await wait(0) 
      const doc = new jsPDF(
      {
         orientation: "landscape",
      })
      doc.setFontSize(8)
      var d = new Date();
      var n = d.toLocaleDateString();
      var t = d.toLocaleTimeString();
      doc.setFontSize(12)
      doc.text("RIEPILOGO ORDINI TUTTI I FORNITORI " + this.pdf_title.store + ' ' + this.pdf_title.season + ' ' + this.pdf_title.year +  ' ' + this.pdf_title.department +  " del " + n + ' ' + t , 15, 10);
      doc.setFontSize(10)
      //doc.text(this.pdf_title.season + '-' + this.pdf_title.year , 15, 15);
     
      doc.autoTable(
      
    
       { html       : '#my-table',
       margin       : {top:20},
       showFoot     : 'lastPage',
       theme        : 'grid',
     
       footStyles   : {halign:'right',fontStyle:'bold',fillColor:'white',textColor:'black',fontSize: 14,cellWidth: 'wrap',},

       columnStyles : { 3: { halign: 'right' }, 4: { halign: 'right' }, 5: { halign: 'right' }, 6: { halign: 'right' } },

        
          didParseCell: function(data) {

                
            if (data.row.cells[0].text != '' && data.row.cells[2].text == '') {
              
              
              data.cell.styles.fontStyle = 'bold';
              data.cell.styles.fontSize = 8
              

            }
            if ( data.row.cells[0].text != '' && data.row.cells[1].text == '') {
              
              
              data.cell.styles.fontStyle = 'bold';
              data.cell.styles.fontSize = 10
              

            }
                    
          }, 
        
        styles : {
          font       : 'helvetica',
          //rowHeight  : 5,  
          fontSize   : 8,
          }
        })
      
     
    addFooters(doc)
         
    var fileName = 'Report'
    window.open(doc.output('bloburl', { filename: fileName }), '_blank');
    this.spinner_pdf = false
    
      
     
    },


      

      
    
    setSeasonId(seasonId,e)
    {           
      this.season.Id        = seasonId
      this.season.name      = e.target.options[e.target.options.selectedIndex].text
      this.pdf_title.season = e.target.options[e.target.options.selectedIndex].text
    },      
    setYear(year,e)
    {
      this.season_year.year = year
      this.pdf_title.year   = e.target.options[e.target.options.selectedIndex].text
    },
    setDepartmentId(departmentId,e)
    {
      this.department.Id        = departmentId
      this.pdf_title.department = 'Tutti i reparti'
      this.department.name = ''
      if(departmentId > 0)
      {
        this.pdf_title.department = e.target.options[e.target.options.selectedIndex].text
        this.department.name = e.target.options[e.target.options.selectedIndex].text
      }
    },

    submit() 
    {
      
      this.getData()
    },  
    
    
       
    
    async getData() {
      
      this.row_total = []
      this.items     = []
      this.msg.title = ''
            
      const sp = {'sp' : 'spOrdersAllSuppliers'}           
     
      const data  = {
        'seasonId':this.season.Id,'season_year':this.season_year.year,
        'companyId':this.company.Id,'departmentId' : this.department.Id,
        'typeId': this.typeId,'storeId':this.store.Id
        
      }
   
      const json  = Object.assign(data, sp)

      this.spinner = true
      
      await api.post(json).then(res => {
         
          if(res.status==200)
            {
              
              this.items = res.data.recordsets[0].filter(item=>item.supplier != null )
             
              this.row_total = res.data.recordsets[0].filter(item=>item.supplier == null)

              
             
            if(this.items.length==0)
              {
                this.msg.title = 'ATTENZIONE '
                this.msg.body = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type  = 1
              
            }
          
          else
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type  = 1
                
                        

          }
      }).catch(err=>{
        
            this.msg.title = 'ATTENZIONE '
            this.msg.body = err.message
            this.msg.type  = 1
              

      }).finally(() => {
          this.spinner = false
        });
      
 

    }
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 700px;
overflow   : auto;
}
.pointer:hover
{
 
  cursor: pointer;
}


.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    
    font-size    : 22px;
    font-weight  : bold;
    background   : rgb(27, 154, 27);
    color        : white; 
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 30px;

 }


.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
 
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
.card-header
{
  height: 45px;
}
</style>